<div class="w-100 ap-mb-spacing-5">
  <gstar-combobox
    [required]="required()"
    [label]="placeholder()"
    [options]="securityTypes()"
    keyProp="name"
    valueProp="securityTypeId"
    trackByKey="securityTypeId"
    [value]="value"
    [disabled]="disabled()"
    (selectItem)="selectSecurityTypeHandler($event)"
    (clearValue)="clearSecurityTypeHandler()" />
</div>
